import React, { useState } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from './modalDataService';

function PortField({ port, error, disabled }) {

    const [touched, setTouched] = useState(false);

    const onChange = (value) => modalDataService.changePort(value);

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="port">Port <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${(error && touched) && 'border-danger'}`}
                    id="port"
                    value={disabled ? "443" : port}
                    placeholder="22"
                    disabled={disabled}
                    onFocus={() => setTouched(true)}
                    onChange={event => onChange(event.target.value)} />
                <div className="modal-v2-field-help">Default: 22 (SSH), 5985 (WinRM)</div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("PortField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        port: addDeviceModal.port || '',
        error: validation.port
    }
}

export default connect(mapStateToProps)(PortField);
